import {useEffect, useState} from 'react';
import {GetSessionTrackUseCase} from '../useCases/GetSessionTrackUseCase';
import type {SessionTrack} from '../models/session.model';

interface UseSessionTrackResult {
  track: SessionTrack | null;
  loading: boolean;
  error: string | null;
}

/**
 * Fetches the full track (session + segments + chronological markers)
 * for a single session. Used by SessionDetailsModal — passing null clears.
 */
export const useSessionTrack = (sessionId: number | null): UseSessionTrackResult => {
  const [track, setTrack] = useState<SessionTrack | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (sessionId === null) {
      setTrack(null);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const useCase = new GetSessionTrackUseCase();
    useCase
      .execute(sessionId)
      .then((data) => {
        if (cancelled) {return;}
        setTrack(data);
      })
      .catch((err: unknown) => {
        if (cancelled) {return;}
        const msg = err instanceof Error ? err.message : 'تعذّر تحميل تفاصيل الجلسة';
        setError(msg);
        setTrack(null);
      })
      .finally(() => {
        if (!cancelled) {setLoading(false);}
      });

    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return {track, loading, error};
};
